import apiClient from '../index';

export const createRecordType = async (data) => {
  try {
    const response = await apiClient.post('/api/recordtype/', data);
    return response.data;
  } catch (error) {
    console.error(`Error on creating record type`, error);
    throw error;
  }
};

export const getAllRecordTypes = async () => {
  try {
    const response = await apiClient.get('/api/recordtype/');
    return response.data;
  } catch (error) {
    console.error(`Error on fetching record types`, error);
    throw error;
  }
};

export const getRecordTypeById = async (id) => {
  try {
    const response = await apiClient.get(`/api/recordtype/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error on fetching record type`, error);
    throw error;
  }
};

export const updateRecordTypeById = async ([id, data]) => {
  try {
    const response = await apiClient.put(`/api/recordtype/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(`Error on updating record type`, error);
    throw error;
  }
};

export const deleteRecordTypeById = async (id) => {
  try {
    const response = await apiClient.delete(`/api/recordtype/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error on deleting record type`, error);
    throw error;
  }
};
